module.exports = __webpack_public_path__ + "static/img/vip3.f65b9013.png";